import { FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";

import config from '../../Config/clientConfig.json'
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSHiddenField from "../../Components/HiddenField/WSHiddenField";
interface StatusProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  orderId?:string
}

export const Refund: React.FC<StatusProps> = ({
  control, errors, register, id, reset,orderId
}) => {


  useEffect(() => {
    reset();
  }, [id, reset]);
  return (
    <Grid >
      <Grid className="modal-input" container spacing={2}>
        <Grid item xs={12} sm={12}>
          <WSSelectField
            options={config.paymentTypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("paymentMethod")}
            id="paymentMethod"
            control={control}
            label="Payment Method"
            name="paymentMethod"
          />
        </Grid>
        <Grid item sm={12}>
          <WSTextField
            id="amountToRefund"
            label="Amount (₹)"
            name="amountToRefund"
            control={control}
            rules={{ required: "please enter the amount" }}

          />
          <WSHiddenField control={control} name="orderId" defaultValue={orderId} />

        </Grid>
      </Grid>
    </Grid>
  );
};
